import { combineReducers } from 'redux';
import calling from './calling.reducer';

const reducer = combineReducers({
	calling,
});

export default reducer;
